<template>
	<div class="father" v-if="isShow">
		<div class="all">
			<div class="certification">
				<div class="topis">
					<div class="left-box">
						<div class="tip">
							<span> 请开始人脸验证 </span>
							<p>
								尊敬的用户，根据规定我们会在您学习过程中多次拍摄并留存人像摄制，<br />用于监管部门审核，为了保证您的隐私请您在摄像视野内确保衣冠整齐。
							</p>
						</div>
						<div class="tip-imgs">
							<div class="tip-box" v-for="(item, index) in tips" :key="index">
								<div class="tip-img">
									<img :src="item.img" alt="" />
								</div>
								<span>{{ item.title }}</span>
							</div>
						</div>
						<div class="bottom">
							<el-button type="primary" @click="Start" :loading="ismedia">{{
                ismedia ? "认证中..." : "开始认证"
              }}</el-button>
						</div>
					</div>
					<div class="right-box">
						<div class="face-box">
							<div class="face-video" v-if="isShowVideo">
								<video ref="video" id="video" width="100%"></video>
								<canvas id="testImg" width="270" height="330">您的浏览器不支持 HTML5 canvas 标签。</canvas>
							</div>
							<div class="face-video" style="height: 280px; width: 100%" v-else></div>
							<div class="face-tip">
								{{ code == null || !ismedia ? "未开始" : actions[code].tip }}
							</div>
							<div class="step">
								<span style="font-weight: 600; color: #f37373"
									v-if="ismedia">{{ endtime }}秒后自动完成认证</span>
								<p v-else style="color: #909399; font-size: 14px">
									请在5秒内完成上方相应动作
								</p>
							</div>
						</div>
					</div>
				</div>
				<!-- </div>
      <div v-else>
        <el-row>
          <el-col :sm="12" :lg="24">
            <el-result
              icon="success"
              title="认证成功"
              subTitle="恭喜您已认证成功"
            >
            </el-result>
          </el-col>
        </el-row>
      </div> -->
			</div>
		</div>
	</div>
</template>

<script>
	// import {
	// 	upload
	// } from "@/api/common";
	// import {
	// 	getUserFaceRandomAction,
	// 	checkFaceActualVerify,
	// 	apigetFaceRes,
	// 	getUserInfo,
	// } from "@/api/user";

	// import {
	// 	saveFace
	// } from "@/api/course";
	export default {
		props: [
			'conts'
		],
		data() {
			return {
				isShowVideo: true,
				code: null,
				ismedia: false,
				isShow: false,
				endtime: 3,
				mediaRecorderData: {},
				videoCecorded: [],
				mediaDevices: null,
				ctracker: "",
				video: "",
				imgUrl: "",
				userinfo: [],
				//动作0=眨眼,4=抬头,5=低头
				actions: {
					0: {
						tip: "请您正视摄像头"
					},
					4: {
						wav: require("@/assets/wav/tt.wav"),
						tip: "请您抬头"
					},
					5: {
						wav: require("@/assets/wav/dt.wav"),
						tip: "请您低头"
					},
				},
				tips: [{
						title: "正对摄像头",
						img: require("@/assets/face/1.svg")
					},
					{
						title: "光线充足",
						img: require("@/assets/face/2.svg")
					},
					{
						title: "放慢动作",
						img: require("@/assets/face/3.svg")
					},
				],
				is_face: "0",
			};
		},
		mounted() {
			//console.log('clmtrackr',clmtrackr);
		},
		methods: {
			open() {
				this.isShow = true;
			},
			close() {
				this.isShow = false;
			},
			playAudio() {
				// 注：需支持资源文件跨域
				(async () => {
					const audioCtx = new AudioContext();
					const source = audioCtx.createBufferSource();

					const getData = async () => {
						let url = this.actions[this.code].wav;

						await fetch(url).then((response) => {
							response.arrayBuffer().then((buffer) => {
								audioCtx.decodeAudioData(buffer, (decodedData) => {
									source.buffer = decodedData;
									source.connect(audioCtx.destination);
								});
							});
						});
					};
					getData();
					source.start(0);
				})();
			},
			async Start() {
				// //获取动作
				// if (this.ismedia) {
				//   return;
				// }
				// if (this.is_face == "1") {
				//   let { code, data, msg } = await getUserFaceRandomAction({
				//     type: "study",
				//   });
				//   if (code == 1) {
				//     this.code = data.code;
				//   } else {
				//     return this.$message({
				//       showClose: true,
				//       message: msg,
				//       type: "error",
				//     });
				//   }
				// }
				this.code = 0;
				this.video = document.getElementById("video");
				this._initMedia();

				//this.initClmTrackr();
			},

			//视频录制
			startRecording(stream) {
				this.mediaRecorderData = new MediaRecorder(stream);
				this.mediaRecorderData.start();
				this.mediaRecorderData.addEventListener("dataavailable", (e) => {
					if (e.data.size > 0) {
						this.videoCecorded.push(e.data); //视频录制视频流数据
					}
				});
				//录制关闭触发
				this.mediaRecorderData.addEventListener("stop", () => {
					if (this.videoStatus != 1) {
						// console.log('进入上传');
						this.updataVideo(); //上传实时录制的视频
					}
				});
			},
			//上传视频
			async updataVideo() {
				this.chack(this.imgUrl)
				// //console.log("上传视频");
				// var file = new File(
				//   this.videoCecorded,
				//   "video-" + new Date().toISOString().replace(/:|\./g, "-") + ".mp4",
				//   {
				//     type: "video/mp4",
				//   }
				// );
				// var formData = new FormData();
				// formData.append("file", file);
				// let { code, data, msg } = await upload(formData);
				// if (code !== 1) {
				//   this.ismedia = false;
				//   return this.$message({
				//     showClose: true,
				//     message: msg,
				//     type: "error",
				//   });
				// }
				// //console.log('data',data);
				// //this.vaideUrl = data.url;
				// if (this.is_face == "1") {
				//   this.chack(this.imgUrl);
				// } else {
				//   saveFace({
				//     duration_id: this.$route.query.jid,
				//     file: data.url,
				//     image: this.imgUrl,
				//   }).then((res) => {
				//     if (res.code !== 1) {
				//       return this.$message({
				//         showClose: true,
				//         message: res.msg,
				//         type: "error",
				//       });
				//     }
				//     this.$emit("faceEnd");
				//     this.close();
				//     this.$message({
				//       message: res.msg,
				//       type: "success",
				//     });
				//   });
				// }
			},
			//上传图片
			async crooper() {
				var date = new Date();
				var year = date.getFullYear(); //月份从0~11，所以加一
				let month = date.getMonth();
				console.log("month", month);
				var dateArr = [
					date.getMonth() + 1,
					date.getDate(),
					date.getHours(),
					date.getMinutes(),
					date.getSeconds(),
				];
				//如果格式是MM则需要此步骤，如果是M格式则此循环注释掉
				for (var i = 0; i < dateArr.length; i++) {
					if (dateArr[i] >= 1 && dateArr[i] <= 9) {
						dateArr[i] = "0" + dateArr[i];
					}
				}
				var strDate =
					year +
					"-" +
					dateArr[0] +
					"-" +
					dateArr[1] +
					" " +
					dateArr[2] +
					":" +
					dateArr[3] +
					":" +
					dateArr[4];
				//此处可以拿外部的变量接收  strDate:2022-05-01 13:25:30
				//this.date = strDate;
				console.log("strDate", strDate);
				var canvas1 = document.getElementById("testImg");
				var context1 = canvas1.getContext("2d");
				context1.drawImage(this.video, 0, 0, 270, 330);
				context1.lineWidth = 0.5;
				//context1.lineJoin = "round";//加圆角
				// context1.fillStyle = "rgb(0,0,0,0.5)";
				// context1.fillRect(0, 240, 220, 93);
				/*  context1.fillStyle = "#ff0";
				// 设置水平对齐方式
				context1.textAlign = "center";
				// 设置垂直对齐方式
				context1.textBaseline = "middle";
				// 绘制文字（参数：要写的字，x坐标，y坐标） */
				// let xs = 10;
				// let ys = 260;

				// context1.font = "1rem Open Sans,Microsoft YaHei";
				// context1.strokeStyle = "black";
				// context1.strokeText("姓名：" + this.userinfo.nickname, xs, ys);
				// this.userinfo.mobile = this.userinfo.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
				// context1.strokeText("电话：" + this.userinfo.mobile, xs, ys + 20);
				// context1.strokeText('甘建投安教-人脸验证', xs, ys + 40);
				// context1.fillText('时间：' + strDate, xs, ys + 60);
				// context1.fillStyle = "white";
				// context1.font = "1rem Open Sans,Microsoft YaHei";
				// context1.fillText("姓名：" + this.userinfo.nickname, xs, ys);
				// this.userinfo.mobile = this.userinfo.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
				// context1.fillText("电话：" + this.userinfo.mobile, xs, ys + 20);
				// context1.fillText('甘建投安教-人脸验证', xs, ys + 40);
				// context1.fillText('时间：' + strDate, xs, ys + 60);
				let quality = 1
				var base64 = canvas1.toDataURL("image/jpeg", quality); //将base64格式转为图片
				/* */
				/* 将图片转为文件对象 */
				var arr = base64.split(",");
				var mime = arr[0].match(/:(.*?);/)[1];
				var bstr = window.atob(arr[1]); // 解码base-64编码的数据
				var n = bstr.length;
				var u8arr = new Uint8Array(n); // 无符号整型数组
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				let crooperImg = new File(
					[u8arr],
					"image-" + new Date().toISOString().replace(/:|\./g, "-") + ".jpg", {
						type: mime
					}
				);
				var formDa = new FormData();
				console.log(crooperImg)

				formDa.append("file", crooperImg);
				//上传照片到服务器
				this.$http({
						method: 'POST',
						url: '/common/upload',
						headers: {
							requireAuth: false // 这里通过设置requireAuth为true来启用token检查
						},
						data: formDa
					})
					.then(response => {
						console.log(response)
						if (response.code != 1) {
							this.ismedia = false;
							return this.$message({
								showClose: true,
								message: response.msg,
								type: "error",
							});
						} else {
							this.imgUrl = response.data.url;
						}

					})
					.catch(error => {
						console.log(error)
					})
				// let {
				// 	code,
				// 	data,
				// 	msg
				// } = await upload(formDa);
				// if (code !== 1) {
				// 	this.ismedia = false;
				// 	return this.$message({
				// 		showClose: true,
				// 		message: msg,
				// 		type: "error",
				// 	});
				// }
				// this.imgUrl = data.url;
			},
			//人脸云端验证
			async chack(vaideUrl) {
				//console.log("人脸云端验证");
				//获取单位名称

				this.$http({
						method: 'POST',
						url: '/Face/CheckFace',
						headers: {
							requireAuth: true // 这里通过设置requireAuth为true来启用token检查
						},
						data: {
							edu_course_id: this.$route.query.course_id,
							edu_directory_id: this.$route.query.directory_id,
							edu_duration_id: this.$route.query.duration_id,
							image: vaideUrl,
						}
					})
					.then(response => {
						console.log(response)
						this.isShowVideo = false;
						this.ismedia = false;
						if (response.code != 1) {
							return this.$message({
								showClose: true,
								message: response.msg,
								type: "error",
							});
						} else {
							this.$emit("faceEnd");
							this.close();
							//成功返回
							return this.$message({
								showClose: true,
								message: response.msg,
								type: "success",
							});
						}

					})
					.catch(error => {
						console.log(error)
					})
				// let {
				// 	code,
				// 	msg
				// } = await apigetFaceRes({
				// 	image: vaideUrl,
				// 	type: "study",
				// 	duration_id: this.$route.query.jid,
				// });
				this.isShowVideo = false;
				this.ismedia = false;
				if (code !== 1) {
					return this.$message({
						showClose: true,
						message: msg,
						type: "error",
					});
				}
				this.$emit("faceEnd");
				this.close();
				//成功返回
				return this.$message({
					showClose: true,
					message: msg,
					type: "success",
				});
			},
			//停止视频录制#关闭摄像头
			stopLive() {
				console.log("1", this.mediaRecorderData);
				if (this.mediaRecorderData) {
					this.mediaRecorderData.stop(); //关闭录制
					this.mediaDevices.forEach((track) => track.stop()); //关闭摄像头
				}
			},
			//初始化摄像头
			_initMedia() {
				console.log()
				this.isShowVideo = true;
				this.endtime = 5;
				let constraints = {
					audio: false,
					video: {
						width: "270",
						height: "330"
					},
				};
				let _this = this;
				// 调用浏览器摄像头
				navigator.mediaDevices
					.getUserMedia(constraints)
					.then((mediaStream) => {
						_this.mediaDevices = mediaStream.getTracks();
						_this.video = _this.$refs.video;
						// 将结果分配给 video 标签
						_this.video.srcObject = mediaStream;
						_this.startRecording(mediaStream); //开始录制视频
						_this.video.onloadedmetadata = function() {
							// 元数据加载后，播放
							_this.video.play();
							setTimeout(function() {
								_this.crooper();
							}, 2000);
							// if (_this.is_face == "1") {
							//   _this.playAudio();
							// } else {
							//   _this.crooper();
							// }
							_this.ismedia = true;
							let Interval = setInterval(() => {
								if (_this.endtime <= 0) {
									_this.stopLive();
									clearInterval(Interval);
								} else {
									_this.endtime -= 1;
									//console.log(_this.endtime);
								}
							}, 1000);
						};
					})
					.catch((err) => {
						//console.log(err);
						_this.ismedia = false;
						this.$message({
							showClose: true,
							message: "唤起摄像头失败,请给予相应权限",
							type: "error",
						});
					});
			},
		},
	};
</script>

<style scoped lang="scss">
	.father {
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.3);
		position: fixed;
		z-index: 13;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;

		.all {
			width: 800px;
			height: 600px;
			background-color: #fff;
			position: fixed;
			margin: auto;
			left: 0;
			right: 0;
			top: 0;
			bottom: 0;

			.certification {
				padding-top: 30px;
				display: flex;
				flex-direction: column;

				.topis {
					display: flex;
					width: 100%;
					justify-content: space-between;

					.right-box {
						width: 50%;
						display: flex;
						justify-content: center;
						align-items: center;

						.face-box {
							height: 529px;
							width: 278px;
							padding: 20px 30px 20px 30px;
							background-image: url("../assets/face/face.png");
							background-repeat: no-repeat;
							background-size: 100% 100%;

							.face-tip {
								display: flex;
								align-items: center;
								justify-content: center;
								font-weight: 400;
								font-size: 30px;
								color: #3f57b2;
								padding-top: 50px;
							}

							.step {
								display: flex;
								align-items: center;
								justify-content: center;
								width: 80%;
								padding-top: 40px;
								margin: auto;

								div {
									color: #3b5aa9;
									border: 1px solid #3b5aa9;
									width: 56px;
									height: 56px;
									border-radius: 50%;
									display: flex;
									align-items: center;
									justify-content: center;
								}
							}

							.face-video {
								background-image: url("../assets/face/face-1.png");
								background-repeat: no-repeat;
								background-size: 100% 100%;
								width: 270px;
								height: 340px;
								display: flex;
								align-items: center;
								justify-content: center;
								position: relative;

								canvas {
									position: absolute;
									display: none;
								}
							}

							background-color: #808080;
						}
					}

					.left-box {
						width: 50%;
						padding-left: 50px;

						.bottom {
							margin: 50px 0 0 100px;
						}

						.tip-imgs {
							width: 80%;
							display: flex;
							padding-top: 44px;
							justify-content: space-between;

							.tip-box {
								display: flex;
								flex-direction: column;
								align-items: center;

								span {
									color: #7e8b9d;
									font-size: 12px;
									margin-top: 10px;
								}

								.tip-img {
									background: #ebf4ff;
									border-radius: 8px;
									padding: 8px 20px 8px 20px;

									img {
										width: 33px;
										height: 36px;
									}
								}
							}
						}

						.tip {
							line-height: 30px;

							span {
								font-size: 14px;
								color: #808080;
							}

							p {
								font-size: 12px;
								color: #808080;
							}
						}
					}
				}
			}
		}
	}
</style>
